import { z } from "zod";

const schema = z.object({
  VITE_SUPABASE_URL: z.url(),
  VITE_SUPABASE_ANON_KEY: z.string().min(20),
  /** Optional override; defaults to the public Storage bucket of the project. */
  VITE_MEDIA_BASE_URL: z.string().optional(),
  /** Optional; without it the UI states that push is not configured. */
  VITE_VAPID_PUBLIC_KEY: z.string().optional(),
});

const parsed = schema.safeParse(import.meta.env);

export const envError = parsed.success ? null : parsed.error.issues.map((i) => i.path.join(".")).join(", ");

export const env = parsed.success
  ? parsed.data
  : { VITE_SUPABASE_URL: "http://invalid.local", VITE_SUPABASE_ANON_KEY: "missing-anon-key-xxxxxxxx", VITE_MEDIA_BASE_URL: undefined, VITE_VAPID_PUBLIC_KEY: undefined };

export const mediaBaseUrl = (env.VITE_MEDIA_BASE_URL || `${env.VITE_SUPABASE_URL}/storage/v1/object/public/studio-media`).replace(/\/$/, "");

export function mediaUrl(path: string | null | undefined): string | undefined {
  if (!path) return undefined;
  return `${mediaBaseUrl}/${path.split("/").map(encodeURIComponent).join("/")}`;
}

export const functionsUrl = `${env.VITE_SUPABASE_URL.replace(/\/$/, "")}/functions/v1`;
